<template>
  <div class="exam_page">
    <span class="exam_page_span"></span>
    <div class="exam_main" ref="middle_page">
      <div class="examPage">
        <div class="exam_begins_box" style="text-align: center">
          <button class="el-button el-button--default is-round exam_btn"  @click="goto_lesson">{{$t('common.returnButton')}}</button>
          <p class="examination_notes" style="font-weight: 500">{{$t('home.learningProcess')}}</p>
          <div class="el-divider el-divider--horizontal"></div>
<!--          <div class="exam_begins_rule"></div>-->
          <el-row width="500px">
            <el-col :span="6" style="font-size: 18px;text-align: right;color: #29aa82">{{$t('home.courseName')}}:
            </el-col><el-col :span="6" style="padding-left: 20px;font-size: 18px;text-align: left;color: #29aa82;min-width: 260px">{{courseName}}</el-col>
          </el-row>
          <el-row width="500px" style="text-decoration:underline;cursor:pointer;">
            <el-col :span="6" style="font-size: 18px;text-align: right;color: #29aa82">{{$t('courseScoreStatistics.beginLearningTime')}}:</el-col>
            <el-col :span="6" style="padding-left: 20px;font-size: 18px;text-align: left;color: #29aa82;min-width: 260px">{{beginDate}}</el-col>
          </el-row>
          <el-row width="500px" style="text-decoration:underline;cursor:pointer;">
            <el-col :span="6" style="font-size: 18px;text-align: right;color: #29aa82">{{$t('courseScoreStatistics.validityPeriod')}}:</el-col>
            <el-col :span="6" style="padding-left: 20px;font-size: 18px;text-align: left;color: #29aa82;min-width: 260px">{{validity}}</el-col>
          </el-row>
<!--          <div class="exam_begins_rule"></div>-->
          <div class="el-divider el-divider--horizontal"></div>
          <el-row>
            <el-col :span="24"><ve-pie :title="chartTitle" :data="chartData" height="380px"></ve-pie></el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    name: 'course_score_statistics',
    data() {
      return {
        courseName:"",
        beginDate:"2020-05-01",
        validity:"2020-05-01~2020-05-31",
        chartData: {
          columns: ['分值范围', '分钟'],
          radius : '10%',
          rows: [
            { '分值范围': '已完成课时', '分钟': 3 },
            { '分值范围': '未完成课时', '分钟': 10 }
          ]
        }
      }
    },
    mounted() {
      //获取设备屏幕的高度
      const h = document.body.clientHeight - 50
      // this.$refs.middle_page.style.minHeight = h + "px";
      this.$autoLogin().then(() => {
        //接收参数
        this.courseId = this.$route.query.courseId;
        this.courseName = this.$route.query.courseName;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");
        //获取考试历史信息
        this.$api.post("/studyCourseQuestion/getPastExamInfo", {
          "courseId": this.courseId
        }).then(
          (response) => {
            this.restCount = response.data.restCount;
            this.maxScore = response.data.maxScore == null ? "--" : response.data.maxScore;
            this.recentScore = response.data.recentScore == null ? "--" : response.data.recentScore;
          }
        )

      }, () => {
        //未登录跳回首页
        // this.$router.push({
        //   path: "/home"
        // })
      })
    },
    methods: {
      GotestPage: function() {
        this.$router.push({
          path: "/home/testPage",
          query: {
            courseId: this.courseId,
            courseName: this.$route.query.courseName
          }
        })
      },
      goto_lesson: function() {
        let outlineInfo = {
          "courseId": this.$route.query.courseId,
          "courseName": this.$route.query.courseName
        };
        this.$router.push({
          path: "/home/curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo)
          }
        })
      },
    }
  }
</script>

<style scoped="scoped">

  .page-bk-col{
    background-color: #ffffff;
  }
  .form-item{
    margin-left: 50px;
  }
  .font_col {
    color: #ffffff;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }
  .exam_page {
    width: 100%;
    background-image: url(../../../static/images/bg/personset_bg.jpg);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    /*width: 100%;
    background: url(/static/images/bg/personset_bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    position: relative;*/
  }

  .exam_main {
    background-color: rgb(65, 65, 65,0.5);
    width: 100%;
    height: 100%;
    min-height: 100%;
    padding-bottom: 50px;
  }

  .curriculum_page_span {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, .3);
  }

  .examPage {
    /*min-width: 1800px;*/
    width: 80%;
    height: 100%;
    margin: 0 auto;
    padding-top: 20px;
  }

  .examCenter_img {
    margin-top: 40px;
    width: 40%;
    margin-left: calc(20% - 30px);
    position: relative;
  }

  .examCenter_img img {
    height: 120px;
  }

  .examCenter_img p:first-child {
    font-size: 40px;
    color: #FAFAFA;
    font-family: marzo-w00-regular, fantasy;
    font-weight: 400;
  }

  .examCenter_img p:first-child span {
    font-size: 40px;
    color: #FF5252;
    font-family: braggadocio-w01, fantasy;
    font-weight: 400;
  }

  .examCenter_img p:nth-child(2) {
    font-size: 45px;
    color: #E8E6E6;
    font-family: roboto-thin, roboto, sans-serif;
    font-weight: 400;
  }


  .exam_begins_box {
    min-width: 700px;
    width: 70%;
    padding: 30px;
    border-radius: 15px;
    margin-left: 180px;
    margin-top: 80px;
    background-color: #ecf5ff;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
    position: relative;
  }
  .course_box {
    /*min-width: 1250px;*/
    width: 100%;
    /*   padding: 30px;*/
    border-radius: 15px;
  : 10px auto;
    background-color: rgba(0, 0, 0, 0.3);
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
    position: relative;
  }

  .exam_page_span {
    position: absolute;
    top: 0;
    left: 0;
    /*height: 100%;*/
    width: 100%;
    background-color: rgba(0, 0, 0, .3);
  }

  .examination_notes {
    height: 20px;
    font-size: 20px;
    color: black;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_begins_box .exam_begins_rule {
    position: relative;
    display: -webkit-flex;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px #414141 solid;
  }

  .exam_begins_rule .exam_begins_rule_title {
    width: auto;
    height: 20px;
    margin-right:10px;
    font-size: 14px;
    color: #E8E6E6;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_begins_rule .exam_begins_rule_content {
    width: 520px;
    min-height: 20px;
    position: relative;
    display: block;
  }

  .exam_begins_rule .exam_begins_rule_content p {
    min-height: 20px;
    line-height: 20px;
    display: flex;
    font-size: 14px;
    color: #E8E6E6;
    text-align: left;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_notes {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #E8E6E6;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_notes:first-child {
    margin-top: 40px;
  }

  .exam_btn {
    margin: -28px 0;
    margin-top: 3px;
    display: block;
    /*text-align: left;*/
    /*font-size: 16px;*/
    /*color: #323232;*/
    background-color: unset;
    padding: 6px 17px 6px 17px;
    /*border: 1px solid #323232;*/
    border-radius: 20px;
    /*font-family: source-han-sans-simplified-c, sans-serif;*/
    /*font-weight: 200;*/
    /*font-style: normal;*/
    /*transition:0.5s ease;*/
  }

  .exam_btn:hover {
    color: #000;
    background-color: #fff;
    transition:0.5s ease;
  }
  .item {
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }
  .el-divider--horizontal {
    display:block;
    height:1px;
    width:100%;
    margin:24px 0
  }
  .el-divider {
    background-color: #dcdfe6;
    position: relative
  }

</style>



// WEBPACK FOOTER //
// src/views/exam/courseProgress.vue